'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSite$002dScope$0024 from "./presto.types$-Site-Scope$.js";
var $p;
/** @constructor */
function $c_Lpresto_SiteTables$$anon$7() {
}
export { $c_Lpresto_SiteTables$$anon$7 as $c_Lpresto_SiteTables$$anon$7 };
$p = $c_Lpresto_SiteTables$$anon$7.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_SiteTables$$anon$7;
/** @constructor */
function $h_Lpresto_SiteTables$$anon$7() {
}
export { $h_Lpresto_SiteTables$$anon$7 as $h_Lpresto_SiteTables$$anon$7 };
$h_Lpresto_SiteTables$$anon$7.prototype = $p;
$p.aR = (function(item) {
  var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a;
  var this$2 = item.qm;
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($x_1, (this$2.k() ? "" : this$2.q()), $j_presto$002etypes$0024$002dSite$002dScope$0024.$m_Lpresto_types$SiteScope$().cIO());
});
var $d_Lpresto_SiteTables$$anon$7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_SiteTables$$anon$7, "presto.SiteTables$$anon$7", ({
  Ri: 1,
  A: 1
}));
export { $d_Lpresto_SiteTables$$anon$7 as $d_Lpresto_SiteTables$$anon$7 };
//# sourceMappingURL=presto.-Site-Tables$$anon$7.js.map
